import { useEffect, useRef, useState } from "react";
import ButtonComponent from "../elements/ButtonComponent";
import InputComponent from "../elements/InputComponent";
import { Controller, useForm } from "react-hook-form";
import { axiosPrivate } from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { USER_HOME_CONTEXT, USER_PASS_LOGIN } from "../../api/apiClient";

const LogedInBefor = ({
  errors,
  handleScroll,
  modalContentRef,
  forgetPasswordModal,
  goToOTP,
  closeModal,
  navigateHere,
}: any) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const {
    handleSubmit,
    formState: { isValid },
    control,
    watch,
  } = useForm();

  const enterUserPass = async (formData: any) => {
    const { phone_number_or_username, password } = formData;

    try {
      setIsButtonDisabled(true);
      if (!isValid) return;

      const response = await axiosPrivate.post(
        USER_PASS_LOGIN,
        JSON.stringify({ username: phone_number_or_username, password }),
        {}
      );
      localStorage.setItem(
        "access_token",
        String(response?.data?.data?.access_token)
      );
      localStorage.setItem("access_token", response?.data?.data?.access_token);
      document.cookie = `access_token=${response?.data?.data?.access_token}; path=/; max-age=86400`;
      localStorage.setItem("user_state", response?.data?.data?.user_state);
      localStorage.setItem("refresh", response?.data?.data?.refresh_token);
      if (navigateHere) {
        if (response?.status >= 200 && response.status < 300) {
          const res = await axiosPrivate.get(USER_HOME_CONTEXT, {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              "Authorization":response?.data?.data?.access_token? `Bearer ${response?.data?.data?.access_token}`:null,
              // prettier-ignore
            },
          });
          localStorage.setItem("user_state", res?.data?.data?.user_state);
        }
        navigate(navigateHere);
      } else {
        if (response?.status >= 200 && response.status < 300) {
          const res = await axiosPrivate.get(USER_HOME_CONTEXT, {
            headers: {
              // prettier-ignore
              "Authorization": `Bearer ${response?.data?.data?.access_token}`,
              // prettier-ignore
              "accept": "application/json",
            },
          });
          localStorage.setItem("user_state", res?.data?.data?.user_state);
        }
        closeModal();
      }
    } catch (error) {
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const maxLength =
    watch("phone_number_or_username")?.charAt(0) === "0" ? 11 : 100;

  return (
    <>
      <div className=" flex items-end justify-start rounded-t pl-3 pt-2">
        <button
          type="button"
          onClick={closeModal}
          className="text-gray-700 bg-transparent rounded-lg w-8 h-8 ms-auto inline-flex justify-end items-center  "
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <div className="mx-8">
        <form onSubmit={handleSubmit(enterUserPass)} className=" w-full">
          <div
            ref={modalContentRef}
            onScroll={handleScroll}
            className=" max-h-[356px] flex flex-col gap-6"
          >
            <div className="flex flex-col items-center justify-center gap-8">
              <img
                src="/icons/LogoNamePlusFinger.svg"
                className="w-[113px] h-[36px]"
                alt="logo vam30"
              />
            </div>
            <label className="text-Title/20/Bold">ورود</label>

            <div className="flex flex-col ">
              <Controller
                name="phone_number_or_username"
                control={control}
                render={({ field }) => (
                  <InputComponent
                    {...field}
                    maxLength={maxLength}
                    label="شماره موبایل یا نام کاربری"
                    type="text"
                    size="regular"
                    errors={errors?.phone_number_or_username}
                    control={control}
                    svgIcon={
                      <img
                        src="/icons/phone-light.svg"
                        alt="lastName icon"
                        width={12}
                      />
                    }
                    inputRef={(el: any) => {
                      inputRef.current = el;
                      if (el) el.focus();
                    }}
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <div className="flex flex-col w-full">
                    <div className="relative w-full">
                      <button
                        type="button"
                        className="absolute z-30 inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <img
                            src={`/icons/eye-outline.svg`}
                            alt="eye-outline"
                          />
                        ) : (
                          <img
                            src={`/icons/eye-slash-outline.svg`}
                            alt="eye-slash-outline.svg"
                          />
                        )}
                      </button>
                      <InputComponent
                        paddingStart={"pl-8"}
                        itemsLtr={true}
                        direction="ltr"
                        {...field}
                        label="رمز عبور"
                        type={showPassword ? "text" : "password"}
                        size="regular"
                        errors={errors?.password}
                        control={control}
                        svgIcon={
                          <img
                            src="/icons/lock-outline.svg"
                            alt="lastName icon"
                            width={16}
                          />
                        }
                      />
                    </div>
                    <p
                      onClick={() => forgetPasswordModal()}
                      className="text-primary-600 text-Body-OneLine/14/Regular mb-5 hover:text-primary-400 cursor-pointer"
                    >
                      فراموشی رمز عبور
                    </p>
                  </div>
                )}
              />
            </div>
          </div>

          <div className="flex flex-col items-center gap-1 pb-3">
            <ButtonComponent
              isClicked={isButtonDisabled}
              disabled={isButtonDisabled}
              className="w-full h-[40px]"
              type="submit"
            >
              ورود
            </ButtonComponent>
            <ButtonComponent
              type="button"
              bgColor="bg-white"
              textColor="text-primary-600"
              variant="text"
              className="w-full h-[40px]"
              onClick={() => goToOTP()}
            >
              ورود با پیامک{" "}
              <span className="text-primary-800 pr-1 text-Title/16/Bold">
                {" "}
                (ثبت نام){" "}
              </span>
            </ButtonComponent>
          </div>
        </form>
      </div>
    </>
  );
};

export default LogedInBefor;
